'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')

var DevicesList = function () {
  var Controller = Marionette.Object.extend({
    listDevices: function (options) {
      var self = this
      self.region = options.region

      if (options.devices) {
        self.devices = options.devices
      } else {
        self.devices = App.globalChannel.request('device:entities')
      }

      if (options.devicesGeo) {
        self.devicesGeo = options.devicesGeo
      } else {
        self.devicesGeo = App.globalChannel.request('device:geo:entities')        
      }        

      self.layout = self.getLayoutView(options.devicesGeo)

      //  _.debounce(self.layout.updateMap, 1000)

      // view events
      // self.layout.on('childview:device:edit', _.bind(self.onEdit, self))
      App.globalChannel.on('map:device:control', _.bind(self.onControl, self))
      App.globalChannel.on('map:device:show', _.bind(self.onShow, self))
      App.globalChannel.on('map:device:edit', _.bind(self.onEdit, self))
      // App.globalChannel.on('devices:event:updated', _.bind(self.onDeviceUpdate, self))
      
      // temporary setup
      self.layout.on('toggle:list', function () {
        App.globalChannel.trigger('devices:list', {devices: self.devices, devicesGeo: self.devicesGeo, region: self.region})
      })
      self.layout.on('toggle:map', function () {
        App.globalChannel.trigger('devices:map', {devices: self.devices, devicesGeo: self.devicesGeo, region: self.region})
      })

      self.layout.on('render', function () {})
      // 
      self.region.show(self.layout)
    // App.rootLayout.showChildView('mainRegion', self.layout)
    },
    onShow: function (args) {
      //console.log(args);
      var model = App.globalChannel.request('device:entity', args.deviceId)
     // var model = this.devices.get(args.deviceId)
      App.globalChannel.trigger('device:show', {model: model})
    },
    onControl: function (args) {
      var model = App.globalChannel.request('device:entity', args.deviceId)

      //var model = this.devices.get(args.deviceId)
      App.globalChannel.trigger('device:control', {region: App.rootLayout.getRegion('dialogRegion'), device: model})
    },
    onEdit: function (args) {
      var model = App.globalChannel.request('device:entity', args.deviceId)

      //var model = this.devices.get(args.deviceId)
      App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), device: model})
    },
    onDeviceUpdate: function(device) {
      // console.log('updater')
      // console.log(device)
      if (!device) return

      // find the geofeature
      let geoDevices = this.devicesGeo.get('data')
      let geoFeature = _.find(geoDevices, (o) => {
        return (o.properties.id === device._id)
      })

      if (!geoFeature) return
      // get the properties and update feature
      let properties = _.pick(device, ['error', 'online'])
      geoFeature.properties = Object.assign(geoFeature.properties, properties)

      // get the sensors and update feature
      if (device.type === 'parking_node') {
        if (!geoFeature.sensors) geoFeature.sensors = {};
        geoFeature.sensors = Object.assign(geoFeature.sensors, {'la':Math.random(), 'parking_detect':_.get(device, 'sensors.parking_detect.value')});
      }

      // update the map
      this.layout.throttledUpdateMap({reset:false})
    },
    getLayoutView: function (model) {
      return new View.layout({model: model})
    }
  })

  return new Controller()
}

module.exports = DevicesList



// WEBPACK FOOTER //
// ./js/modules/devices/map/index.js